<div class="success-page">
  <h2>TikTok connected</h2>
  <p>Your TikTok account is now linked successfully.</p>
  <p class="thank-you">Thank you for connecting your social account.</p>
</div>
